import {CustomEventHandler} from "../utils/CustomEventHandler";
import {gsap} from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import {isMobile, scrollSetting} from "./globalVars";

export default class Parallax {
    constructor(els=[]) {
        this.els = els;
        this.init();
    }

    init() {
        this.addEvent();
    }

    addEvent () {
        CustomEventHandler.addHandler(window,'resize', (e)=>this.onResizeHandler(e));
        this.onResizeHandler();
    }

    setAddMotionEl(className, tX=0, tY=0, tS=0, mT=0) {
        let scrub = scrollSetting.scrub;
        let markers = scrollSetting.markers;
        markers = false;

        gsap.to(className,
            {
                y: tY, x: tX, scale: tS, marginTop:mT,
                scrollTrigger: {
                    trigger:className,
                    start: 'top bottom',
                    end: 'bottom top',
                    scrub: scrub,
                    markers: markers,
                    id:className
                }
            })
    }

    setRemovedMotionEl(className) {
        ScrollTrigger.getById(className).kill(true);
    }

    setAddMotion() {
        if (this.isMotion) return;
        this.isMotion = true;

        for (let i=0;i<this.els.length; i++) {
            this.setAddMotionEl(this.els[i].el, this.els[i].tX, this.els[i].tY, this.els[i].tS, this.els[i].mT);
        }
    }

    setRemoveMotion() {
        if (!this.isMotion) return;
        this.isMotion = false;

        for (let i=0;i<this.els.length; i++) {
            this.setRemoveMotionEl(this.els.el);
        }
    }

    onResizeHandler(e) {
        if (isMobile(window.innerWidth)) {
            this.setRemoveMotion();
        } else {
            this.setAddMotion();
        }

    }
}
